import * as RadixCheckbox from '@radix-ui/react-checkbox';
import { ComponentPropsWithoutRef } from 'react';
import { cn } from '../utils/className';

export type CheckboxProps = ComponentPropsWithoutRef<typeof RadixCheckbox.Root>;

export function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <RadixCheckbox.Root
      className={cn(
        'relative h-4 w-4 shrink-0 rounded border transition-colors',
        // High-contrast base so the box is visible on light mobile popovers
        'border-border-primary-strong bg-surface-primary',
        'hover:border-border-primary-strong',
        `focus-visible:ring-focus focus-visible:ring-1
        focus-visible:outline-none`,
        'disabled:cursor-not-allowed disabled:opacity-50',
        'data-checked:bg-surface-focus!',
        'data-checked:border-border-focus-strong!',
        'data-checked:hover:bg-surface-focus!',
        'data-checked:hover:border-border-focus!',
        'data-indeterminate:bg-surface-focus!',
        'data-indeterminate:border-border-focus!',
        'data-indeterminate:hover:bg-surface-focus!',
        'data-indeterminate:hover:border-border-focus!',
        className
      )}
      {...props}
    >
      <RadixCheckbox.Indicator
        className='flex items-center justify-center text-white'
      >
        {props.checked === 'indeterminate' ? (
          <div className='h-0.5 w-2 rounded-[1.5px] bg-white' />
        ) : (
          <svg
            width='10'
            height='10'
            viewBox='0 0 10 10'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M8.5 2.5L4 7L1.5 4.5'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        )}
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  );
}
